import { render, staticRenderFns } from "./question.vue?vue&type=template&id=5ea833da&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"
import style0 from "./question.vue?vue&type=style&index=0&id=5ea833da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea833da",
  null
  
)

export default component.exports